/**
 * @desc 广告模块
 */
const operateLogList = r => require.ensure([], () => r(require('../views/operateLog/OperateLogList.vue')), 'OperateLogList');

export default [
  //广告列表
  {
    name: 'operateLogList',
    path: '/operateLogList',
    component: operateLogList,
    meta: { title: '日志列表' },
  },
]